import { useCurrentUser } from "@/shared/auth/useCurrentUser";

export function usePermissions(): string[] {
  return useCurrentUser()?.permissions ?? [];
}

export function useHasPermission(...required: string[]): boolean {
  const granted = usePermissions();
  const wildcards = new Set(granted.filter((g) => g.endsWith(":*")).map((g) => g.slice(0, -2)));
  return required.every((r) => {
    if (granted.includes(r)) return true;
    const [resource] = r.split(":");
    return resource ? wildcards.has(resource) : false;
  });
}
